module.exports = __webpack_public_path__ + "img/image06_sp.1a9b91e6.jpg";